module.exports = __webpack_public_path__ + "static/media/RP-A_C_Embroidery_Accademia_White_3955_3377_3364.a5a3ab27.png";